import { render } from "./DynamicTable2 copy.vue?vue&type=template&id=639d57bb&scoped=true"
import script from "./DynamicTable2 copy.vue?vue&type=script&lang=js"
export * from "./DynamicTable2 copy.vue?vue&type=script&lang=js"

import "./DynamicTable2 copy.vue?vue&type=style&index=0&id=639d57bb&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639d57bb"]])

export default __exports__